import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { withRouter } from "react-router";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import MPage from "../templates/mpage";
import FormInput from "../components/forminput";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";

const FormVotacion = (props) => {
  const [municipio, errorMunicipio] = useObtenerMunicipio(
    props.match.params.munUrl
  );
  const [propuestas, guardarPropuestas] = useState(undefined);
  const [error, guardarError] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  // Crear referencia para la sección de "Datos Personales"
  const datosPersonalesRef = useRef(null);

  useEffect(() => {
    if (municipio !== undefined) {
      const obtenerPropuestas = () => {
        axios
          .get(`/api/propuestas?municipioId=${municipio._id}&estado=aceptada`)
          .then((res) => {
            guardarPropuestas(res.data.propuestas);
          })
          .catch((error) => guardarError(true));
      };
      obtenerPropuestas();
    }
    return () => {
      guardarPropuestas(undefined);
    };
  }, [municipio]);

  const actualizarPropuesta = (propuestaId) => {
    setValue("propuestaId", propuestaId, { shouldValidate: true });

    if (datosPersonalesRef.current) {
      datosPersonalesRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onSubmit = (data) => {
    data["municipioId"] = municipio._id;
    data["nombre"] = data["nombre"].toUpperCase();
    data["dir"] = data["dir"].toUpperCase();
    data["propuestaTitulo"] = propuestas.filter(
      (propuesta) => propuesta._id === data["propuestaId"]
    )[0].titulo;

    data["fechaNac"] = `${data["anioNac"]}-${data["mesNac"].padStart(
      2,
      "0"
    )}-${data["diaNac"].padStart(2, "0")}`;

    axios
      .post(`/api/votos/${municipio._id}`, data)
      .then((res) => {
        //Redireccionar
        Swal.fire(
          "¡Hemos recibido tu voto!",
          "Fiscalizaremos la votación y publicaremos los resultados en la página principal.",
          "success"
        );
        props.history.push(`/municipio/${municipio.nombreUrl}`);
      })
      .catch((err) => {
        Swal.fire(
          err.response.data.errorMessage,
          `Hubo un problema al registrar tu voto. Por favor, contáctanos en ${municipio.email} o llamanos/escribinos al ${municipio.tel}.`,
          "error"
        );
      });
  };

  if (errorMunicipio === true || error === true) return <Redirect to="/" />;
  if (municipio === undefined || propuestas === undefined) return null;
  if (municipio.etapa !== "votacion" || municipio.tipoVotacion === "privada")
    return <Redirect to="/" />;

  return (
    <MPage municipio={municipio}>
      <div className="row">
        <div className="col-md-12">
          <h1 className="ppr-titulo centrado my-2">
            Formulario de Votación de Propuesta
          </h1>
          <p>
            Recuerda que solo se permite votar una vez.
            <Link
              to={"/municipio/" + municipio.nombreUrl + "/info"}
              className="m-2 ppr-a"
            >
              Hace click para más información sobre quienes pueden votar.
            </Link>
          </p>
          <small className=" text-muted">
            Los campos indicados con <b>*</b> son obligatorios.
          </small>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="from-group my-4">
              <label htmlFor="propuestaId">* Propuesta Elegida:</label>
              <select
                {...register("propuestaId", {
                  validate: (value) => value !== "0",
                })}
                type="text"
                className="form-control"
                id="propuestaId"
                name="propuestaId"
                defaultValue={props.match.params.propuestaId}
              >
                <option key="placeholder" value="0" disabled>
                  Selecciona una propuesta a votar.
                </option>
                {propuestas.map((propuesta) => (
                  <option key={propuesta._id} value={propuesta._id}>
                    {propuesta.titulo}
                  </option>
                ))}
              </select>
              {errors.propuestaId && (
                <small className="text-danger form-text">
                  Campo Obligatorio.
                </small>
              )}
            </div>
            <div className="row">
              {propuestas.map((propuesta) => (
                <div className="col-md-6 card-deck mx-auto" key={propuesta._id}>
                  <div className="card mb-3">
                    <div className="row">
                      <div className="col-md-4">
                        <img
                          className="thumbnail img-fluid"
                          src={`/api/public/${propuesta.img}`}
                          alt={propuesta.titulo}
                        />
                      </div>
                      <div className="col-md-8">
                        <div className="card-body">
                          {propuesta.eje && (
                            <span className="badge badge-primary tag">
                              {propuesta.eje}
                            </span>
                          )}
                          <h6 className="card-title centrado m-1">
                            {propuesta.titulo}
                          </h6>
                          <small className="card-text centrado m-1">
                            {propuesta.subtitulo}
                          </small>
                          <center>
                            <button
                              type="button"
                              onClick={() => actualizarPropuesta(propuesta._id)}
                              className="btn ppr-btn-azul font-weight-bold m-1 btn-xs"
                            >
                              Seleccionar
                            </button>
                          </center>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <h4 className="ppr-titulo" ref={datosPersonalesRef}>
              Datos Personales
            </h4>
            <FormInput
              register={register}
              error={errors.dni}
              label={"*DNI:"}
              id={"dni"}
              isRequired={true}
              placeholder="DNI de quién vota."
            />
            <FormInput
              register={register}
              error={errors.nombre}
              label={"* Nombre y Apellido:"}
              id={"nombre"}
              isRequired={true}
              placeholder="Nombre y apellido como figuran en el DNI."
            />

            <div className="mb-3">
              <label>* Fecha de Nacimiento:</label>
              <div className="d-flex">
                {/* Día */}
                <input
                  {...register("diaNac", {
                    required: true,
                    min: 1,
                    max: 31,
                  })}
                  type="number"
                  placeholder="Día"
                  className={`form-control me-2 ${
                    errors.diaNac ? "is-invalid" : ""
                  }`}
                />
                {errors.diaNac && (
                  <div className="invalid-feedback">
                    Ingrese un día válido (1-31).
                  </div>
                )}

                {/* Mes */}
                <select
                  {...register("mesNac", { required: true })}
                  className={`form-control me-2 ${
                    errors.mesNac ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Mes</option>
                  <option value="01">Enero</option>
                  <option value="02">Febrero</option>
                  <option value="03">Marzo</option>
                  <option value="04">Abril</option>
                  <option value="05">Mayo</option>
                  <option value="06">Junio</option>
                  <option value="07">Julio</option>
                  <option value="08">Agosto</option>
                  <option value="09">Septiembre</option>
                  <option value="10">Octubre</option>
                  <option value="11">Noviembre</option>
                  <option value="12">Diciembre</option>
                </select>
                {errors.mesNac && (
                  <div className="invalid-feedback">Seleccione un mes.</div>
                )}

                {/* Año */}
                <input
                  {...register("anioNac", {
                    required: true,
                    min: 1900,
                    valueAsNumber: true,
                  })}
                  type="number"
                  placeholder="Año"
                  min="1900"
                  max={new Date().getFullYear()}
                  className={`form-control ${
                    errors.anioNac ? "is-invalid" : ""
                  }`}
                />
                {errors.anioNac && (
                  <div className="invalid-feedback">
                    {`Ingrese un año válido (1900-${new Date().getFullYear()}).`}
                  </div>
                )}
              </div>
            </div>

            <FormInput
              register={register}
              error={errors.dir}
              label={"* Domicilio:"}
              id={"dir"}
              isRequired={true}
              placeholder="Dirección que figura en el DNI."
              type="direccion"
            />
            <FormInput
              register={register}
              error={errors.email}
              label={"* Correo Electrónico:"}
              id={"email"}
              isRequired={true}
              placeholder="Dirección de correo electrónico."
              type="email"
            />
            <FormInput
              register={register}
              error={errors.tel}
              label={"* Teléfono:"}
              id={"tel"}
              isRequired={true}
              placeholder="Número de telefono de contacto."
              type="tel"
            />

            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="dataConfirmation"
                {...register("dataConfirmation", { required: true })}
              />
              <label className="form-check-label" htmlFor="dataConfirmation">
                <b>
                  Confirmo que los datos ingresados son verídicos y correctos.
                </b>
              </label>
              {errors.dataConfirmation && (
                <small className="text-danger form-text">
                  Campo Obligatorio.
                </small>
              )}
            </div>

            <center>
              <button
                type="submit"
                className="btn ppr-btn-verde font-weight-bold m-2 mr-5"
              >
                Guardar
              </button>
              <Link
                to={"/consola"}
                className="btn ppr-btn-verde font-weight-bold m-2"
              >
                Volver
              </Link>
            </center>
          </form>
        </div>
      </div>
    </MPage>
  );
};

export default withRouter(FormVotacion);
